import { create } from "zustand";

interface NavVisibilityState {
  visible: boolean;
  setVisible: (v: boolean) => void;
}

export const useNavVisibilityStore = create<NavVisibilityState>((set) => ({
  visible: true,
  setVisible: (v) => set({ visible: v }),
}));
